import { render } from "./UpstoxAuth.vue?vue&type=template&id=3527a3bb&scoped=true"
import script from "./UpstoxAuth.vue?vue&type=script&lang=js"
export * from "./UpstoxAuth.vue?vue&type=script&lang=js"

import "./UpstoxAuth.vue?vue&type=style&index=0&id=3527a3bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3527a3bb"]])

export default __exports__